import { Icon } from "~/components/ui/Icons";
import type {
  SidebarSocialProps,
  SocialCardProps,
  SocialInfo,
  SocialType,
} from "./types";
import { PostList } from "~/components/ui/PostList";

const SOCIAL_DATA: Record<SocialType, SocialInfo> = {
  facebook: {
    url: "https://www.facebook.com/superguidatv",
    info: "Fans",
  },
  instagram: {
    url: "https://www.instagram.com/superguidatv/",
    info: "Follower",
  },
  twitter: {
    url: "https://twitter.com/SuperGuidaTV",
    info: "Follower",
  },
};

const SocialCardIcon = ({ social }: { social: SocialType }) => {
  switch (social) {
    case "facebook":
      return (
        <Icon.Facebook class="sgtv-size-7 sgtv-fill-[#516eab] md:sgtv-size-5 xl:sgtv-size-7" />
      );
    case "instagram":
      return (
        <Icon.Instagram class="sgtv-size-7 sgtv-fill-[#417096] md:sgtv-size-5 xl:sgtv-size-7" />
      );
    case "twitter":
      return (
        <Icon.Twitter class="sgtv-size-7 sgtv-fill-[#2cc5f6] md:sgtv-size-5 xl:sgtv-size-7" />
      );
  }
};

const SocialCard = ({ counter, social }: SocialCardProps) => {
  return (
    <a
      href={SOCIAL_DATA[social].url}
      class="sgtv-group sgtv-w-full sgtv-overflow-hidden sgtv-border sgtv-border-gray-200 sgtv-py-2"
    >
      <div class="sgtv-mx-auto sgtv-mb-1 sgtv-max-w-max">
        <SocialCardIcon social={social} />
      </div>
      <div class="sgtv-justify-start sgtv-overflow-hidden sgtv-font-open-sans group-hover:sgtv-text-neutral-700">
        <p class="sgtv-text-lg sgtv-font-bold md:sgtv-text-xs xl:sgtv-text-lg">
          {counter}
        </p>
        <p class="sgtv-text-xs md:sgtv-text-xxs xl:sgtv-text-xs">
          {SOCIAL_DATA[social].info}
        </p>
      </div>
    </a>
  );
};

export const SidebarSocial = ({ counters }: SidebarSocialProps) => {
  return (
    <div class="sgtv-flex sgtv-flex-col sgtv-gap-6">
      <PostList.Header label="Seguici sui social" />
      <div class="sgtv-grid sgtv-w-full sgtv-grid-cols-3 sgtv-items-center sgtv-gap-1 sgtv-text-center xl:sgtv-gap-4">
        <SocialCard
          class="sgtv-h-full"
          social="facebook"
          counter={counters.facebook}
        />
        <SocialCard
          class="sgtv-h-full"
          social="instagram"
          counter={counters.instagram}
        />
        <SocialCard
          class="sgtv-h-full"
          social="twitter"
          counter={counters.twitter}
        />
      </div>
    </div>
  );
};
